export class DMVConstants {
	public static readonly REGISTRATION_URI: string = "/dmv/{0}/{1}/registration";
	public static readonly AGENCY_CONFIGURATION_URI: string = "/dmv/{0}/{1}/configuration";
	public static readonly TAG_CATALOG_URI: string = "/dmv/{0}/tagCatalog";
	public static readonly DMV_COST_URI: string = "/dmv/{0}/{2}/registration/{1}/cost";
	public static readonly DONATION_ORGS_URI: string = "/dmv/{0}/donationOrgs";
	public static readonly REGISTRATION_TYPES_URI: string = "/dmv/{0}/registrationTypes";
	public static readonly TIMEOUT: number = 12000;
	public static readonly TIMEOUT_ERROR: string = "Interal system error. Please retry. If this problem persists, please contact our support team for assistance.";
	public static readonly RENEWAL: string = "/dmv/{0}/{1}/registration/renewal";
	public static readonly UPDATE_RENEWAL: string = "/dmv/{0}/{2}/registration/renewal/{1}";
	public static readonly SERVICE_FEE_AMOUNT: string = "/dmv/{0}/{2}/registration/renewal/{1}/fee";
	public static readonly RENEWAL_SUBMIT: string = "/dmv/{0}/{2}/registration/renewal/{1}/submit";
	public static readonly PAYMENT_ACCESS_TOKEN: string = "/payment/{0}/{1}/accessToken";
	public static readonly FUNDING_TOKEN: string = "/payment/{0}/{1}/fundingToken";
	public static readonly ERROR: string = "/payment/{0}/{1}/error";
	public static readonly ERROR_LOG: string = "/meg/{0}/{1}/error";
	public static readonly DUPLICATE_REGISTRATION: string = "/dmv/{0}/{1}/registration/{2}/cost";
}
